<app-outcallcampaign-contact *ngIf="campaign" [campaign]="campaign"></app-outcallcampaign-contact>
